<template>
    <div>
    <span class="label-color item-edit-label" :data-label-id="qrlabel.id" 
    :style='{background: qrlabel.color}' @click.prevent>
    <i class="el-icon-caret-bottom edit-label-icon"></i>
    </span>
    <span class="item-label-name">{{ qrlabel.textDesc }}</span>
    <span class="item-label-num">{{ qrlabel.num }}</span>
    <div id="editLabelContent">
    <div class="dialog-inner-content name-container el-input el-input--small">
      <input class="label-name el-input__inner" placeholder="标签名称" maxlength="25" size="small"/>
    </div>
    <div class="dialog-inner-content label-colors-container">
      <span class="label-color label-color-1 " data-color-id="1"></span>
      <span class="label-color label-color-2 " data-color-id="2"></span>
      <span class="label-color label-color-3 " data-color-id="3"></span>
      <span class="label-color label-color-4 " data-color-id="4"></span>
      <span class="label-color label-color-5 " data-color-id="5"></span>
      <span class="label-color label-color-6 " data-color-id="6"></span>
      <span class="label-color label-color-7 " data-color-id="7"></span>
      <span class="label-color label-color-8 last-in-row " data-color-id="8"></span><br>
      <span class="label-color label-color-9 " data-color-id="9"></span>
      <span class="label-color label-color-10 " data-color-id="10"></span>
      <span class="label-color label-color-11 " data-color-id="11"></span>
      <span class="label-color label-color-12 " data-color-id="12"></span>
      <span class="label-color label-color-13 " data-color-id="13"></span>
      <span class="label-color label-color-14 " data-color-id="14"></span>
      <span class="label-color label-color-15 " data-color-id="15"></span>
      <span class="label-color label-color-16 last-in-row " data-color-id="16"></span><br>
    </div>
    <div class="dialog-footer">
      <el-button  size="small" class="delete-label pull-left"><i class="el-icon-delete"></i></el-button>
      <el-button size="small" class="delete-label">取消</el-button>
      <el-button size="small" type="primary" class="edit-save-label">保存</el-button>
    </div>
  </div>
  </div>
<!--   </router-link> -->
</template>

<script>
import $ from 'jquery'
import '@pp/qtip/jquery.qtip.min.css'
import '@pp/qtip/jquery.qtip.min.js'
export default {
  name: 'qrLabelItem',
  props: ['qrlabel'],
  mounted () {
    const vm = this
    // 为按钮添加tip动作
    $('.item-edit-label').qtip('destroy', true)
    $('.item-edit-label').qtip({
      hide: 'unfocus',
      style: {
        classes: 'qtip-bootstrap' // 风格
      },
      show: 'click',
      content: {
        title: '编辑标签',
        text: $('#editLabelContent').html(),
        button: true
      },
      events: {
        show: function (event, api) {
          let tipId = '#qtip-' + api.get('id')
          // 将便签放到input框中，并初始化button
          let labelname = $(event.originalEvent.target).closest('.list-group-item').find('.item-label-name').html()
          $(this).find('.label-name').val(labelname)
          if (labelname !== '') {
            $(tipId + ' .edit-save-label').removeAttr('disabled')
            $(tipId + ' .edit-save-label').removeClass('is-disabled')
          } else {
            $(tipId + ' .edit-save-label').attr('disabled', 'true')
            $(tipId + ' .edit-save-label').addClass('is-disabled')
          }
          // 查找并选中原有便签所指定的颜色
          let oldColor = $(event.originalEvent.target).closest('.list-group-item').find('.label-color').css('background-color')
          let li = $(tipId + ' .label-color')
          li.removeClass('label-color-selected')
          let sel = li.filter(function (i) {
            return li.eq(i).css('background-color') === oldColor
          })
          if (sel.length !== 0) {
            sel.addClass('label-color-selected')
          }
        },
        render: function (event, api) {
          let tipId = '#qtip-' + api.get('id')
          // 输入时，根据是否有内容，更新按钮状态
          $(tipId + ' .label-name').on('input', function () {
            if ($(this).val() !== '') {
              $(tipId + ' .edit-save-label').removeAttr('disabled')
              $(tipId + ' .edit-save-label').removeClass('is-disabled')
            } else {
              $(tipId + ' .edit-save-label').attr('disabled', 'true')
              $(tipId + ' .edit-save-label').addClass('is-disabled')
            }
          })
          // 为便签选中添加事件
          $(tipId + ' .label-color').on('click', function () {
            $(tipId + ' .label-color').removeClass('label-color-selected')
            $(this).addClass('label-color-selected')
          })
          // 点击cancel-label时响应的事件，关闭tip
          $(tipId + ' .cancel-label').on('click', function () {
            api.hide()
          })
          // 删除便签的事件
          $(tipId + ' .delete-label').on('click', function () {
            let labelid = Number($(event.originalEvent.target).closest('.list-group-item').find('.label-color').attr('data-label-id'))
            $.ajax({
              url: '/v1/user/qrlabels/' + labelid,
              type: 'DELETE',
              dataType: 'json',
              success: function (data) {
                if (data.code === 200) {
                  // 从vuex中将对应的内容便签删除
                  vm.$store.dispatch('deleteOneQrlabel', labelid)
                } else {
                  vm.$message.warning('删除标签失败')
                }
              },
              error: function () {
                vm.$message.warning('异常，请稍后重试')
              }
            })
            api.hide()
          })
          // 点击保存时，进行标签颜色及标签名称修改
          $(tipId + ' .edit-save-label').on('click', function () {
            // 修改便签名称及色彩等
            let labelid = Number($(event.originalEvent.target).closest('.list-group-item').find('.label-color').attr('data-label-id'))
            $.ajax({
              url: '/v1/user/qrlabels/' + labelid,
              type: 'PATCH',
              dataType: 'json',
              data: {
                name: $(tipId + ' input.label-name').val().trim(),
                color: $(tipId + ' .label-color.label-color-selected').css('background-color')
              },
              success: function (data) {
                if (data.code === 200) {
                  vm.$store.dispatch('updateOneQrlabel', data.data)
                } else {
                  vm.$message.warning('更新标签失败，请稍后重试')
                }
              },
              error: function () {
                vm.$message.warning('异常，请稍后重试')
              }
            })
            api.hide()
          })
        }
      }
    })
  }
}
</script>

<style type="text/css" scoped>
.label-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #CCC !important;
  border-radius: 2px;
  cursor: pointer;
}

.label-color:hover {
  border: 1px solid #000 !important;
  box-shadow:0px 0px 2px #f00;
}
.item-edit-label {
  text-align: center;
}
.edit-label-icon {
  font-size: 10px;
  color: #fff;
}
.item-label-name {
  display: inline-block;
}
.item-label-num {
  float: right;
}
#editLabelContent {
  display:none;
}
.dialog-footer {
  position: relative;
  padding: 8px 8px;
  background: #f7f7f7;
  border-top: 1px solid #ddd;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  text-align: right;
  display: block;
}
.name-container {
  margin-bottom: 5px;
}
.label-name {
  width: 154px;
  margin-bottom: 0;
  font-size: 12px;
}
.dialog-inner-content {
    padding: 5px 9px;
}
.label-colors-container {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}
.label-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  border-radius: 2px;
  cursor: pointer;
}
.label-color:hover {
  border: 1px solid #000 !important;
  box-shadow:0px 0px 2px #f00;
}
.label-color-selected {
  border: 1px solid #fff !important;
  box-shadow: 0 0 4px #000;
  cursor: default;
}
.label-color-1 {
  border-color: #da1d00;
  background: #da1d00
}
.label-color-2 {
  border-color: #e9a449;
  background: #e9a449
}
.label-color-3 {
  border-color: #f5cb43;
  background: #f5cb43
}
.label-color-4 {
  border-color: #7ab45f;
  background: #7ab45f
}
.label-color-5 {
  border-color: #54949e;
  background: #54949e
}
.label-color-6 {
  border-color: #4b97d1;
  background: #4b97d1
}
.label-color-7 {
  border-color: #7b65b7;
  background: #7b65b7
}
.label-color-8 {
  border-color: #b5658c;
  background: #b5658c
}
.label-color-9 {
  border-color: #e67f7a;
  background: #e67f7a
}
.label-color-10 {
  border-color: #fbbe7b;
  background: #fbbe7b
}
.label-color-11 {
  border-color: #fce07c;
  background: #fce07c
}
.label-color-12 {
  border-color: #a3cd8d;
  background: #a3cd8d
}
.label-color-13 {
  border-color: #86b5bb;
  background: #86b5bb
}
.label-color-14 {
  border-color: #7db7e5;
  background: #7db7e5
}
.label-color-15 {
  border-color: #a091d2;
  background: #a091d2
}
.label-color-16 {
  border-color: #cd92b0;
  background: #cd92b0
}

</style>
